/// <reference path="../../../../../../typings/index.d.ts" />
/// <reference path="../../basicEmailMarketing.module.ts" />

module Meevo.Plugins.BasicEmailMarketing {
    import PresetStatus = Meevo.Components.Controls.PresetStatus;
    import BasicMarketingDateRangeSelectionEnum = Meevo.Model.BasicMarketingDateRangeSelectionEnum;

    interface IPreset {
        name: string;
        status: PresetStatus;
        enumId: BasicMarketingDateRangeSelectionEnum;
    }

    interface IValidationJson {
        RunReportFor: string;
        LimitDateRangeTo: string;
    }

    const MAP_DATE_RANGE_TO_PRESET = {
        [BasicMarketingDateRangeSelectionEnum.Last7Days]: {
            name: 'BASICMARKETING_LASTSEVENDAYS',
            status: PresetStatus.LastSevenDays,
            enumId: BasicMarketingDateRangeSelectionEnum.Last7Days
        },
        [BasicMarketingDateRangeSelectionEnum.PreviousDay]: {
            name: 'BASICMARKETING_PREVIOUSDAY',
            status: PresetStatus.Yesterday,
            enumId: BasicMarketingDateRangeSelectionEnum.PreviousDay
        },
        [BasicMarketingDateRangeSelectionEnum.Today]: {
            name: 'BASICMARKETING_TODAY',
            status: PresetStatus.Today,
            enumId: BasicMarketingDateRangeSelectionEnum.Today
        },
        [BasicMarketingDateRangeSelectionEnum.Tomorrow]: {
            name: 'BASICMARKETING_TOMORROW',
            status: PresetStatus.Tomorrow,
            enumId: BasicMarketingDateRangeSelectionEnum.Tomorrow
        },
        [BasicMarketingDateRangeSelectionEnum.NextWeek]: {
            name: 'BASICMARKETING_NEXTWEEK',
            status: PresetStatus.NextWeek,
            enumId: BasicMarketingDateRangeSelectionEnum.NextWeek
        },
        [BasicMarketingDateRangeSelectionEnum.ThisWeek]: {
            name: 'BASICMARKETING_THISWEEK',
            status: PresetStatus.ThisWeek,
            enumId: BasicMarketingDateRangeSelectionEnum.ThisWeek
        },
        [BasicMarketingDateRangeSelectionEnum.LastWeek]: {
            name: 'BASICMARKETING_LASTWEEK',
            status: PresetStatus.LastWeek,
            enumId: BasicMarketingDateRangeSelectionEnum.LastWeek
        },
        [BasicMarketingDateRangeSelectionEnum.ThisMonth]: {
            name: 'BASICMARKETING_THISMONTH',
            status: PresetStatus.ThisMonth,
            enumId: BasicMarketingDateRangeSelectionEnum.ThisMonth
        },
        [BasicMarketingDateRangeSelectionEnum.LastMonth]: {
            name: 'BASICMARKETING_LASTMONTH',
            status: PresetStatus.LastMonth,
            enumId: BasicMarketingDateRangeSelectionEnum.LastMonth
        },
        [BasicMarketingDateRangeSelectionEnum.NextMonth]: {
            name: 'BASICMARKETING_NEXTMONTH',
            status: PresetStatus.NextMonth,
            enumId: BasicMarketingDateRangeSelectionEnum.NextMonth
        },
        [BasicMarketingDateRangeSelectionEnum.ThisQuarter]: {
            name: 'BASICMARKETING_THISQUARTER',
            status: PresetStatus.ThisQuarter,
            enumId: BasicMarketingDateRangeSelectionEnum.ThisQuarter
        },
        [BasicMarketingDateRangeSelectionEnum.LastQuarter]: {
            name: 'BASICMARKETING_LASTQUARTER',
            status: PresetStatus.LastQuarter,
            enumId: BasicMarketingDateRangeSelectionEnum.LastQuarter
        },
        [BasicMarketingDateRangeSelectionEnum.NextQuarter]: {
            name: 'BASICMARKETING_NEXTQUARTER',
            status: PresetStatus.NextQuarter,
            enumId: BasicMarketingDateRangeSelectionEnum.NextQuarter
        },
        [BasicMarketingDateRangeSelectionEnum.ThisYear]: {
            name: 'BASICMARKETING_THISYEAR',
            status: PresetStatus.ThisYear,
            enumId: BasicMarketingDateRangeSelectionEnum.ThisYear
        },
        [BasicMarketingDateRangeSelectionEnum.LastYear]: {
            name: 'BASICMARKETING_LASTYEAR',
            status: PresetStatus.LastYear,
            enumId: BasicMarketingDateRangeSelectionEnum.LastYear
        },
        [BasicMarketingDateRangeSelectionEnum.NextYear]: {
            name: 'BASICMARKETING_NEXTYEAR',
            status: PresetStatus.NextYear,
            enumId: BasicMarketingDateRangeSelectionEnum.NextYear
        },
        [BasicMarketingDateRangeSelectionEnum.TwentyFourHours]: {
            name: 'BASICMARKETING_TWENTYFOURHOURS',
            status: PresetStatus.LastTwentyFourHours,
            enumId: BasicMarketingDateRangeSelectionEnum.TwentyFourHours
        },
        [BasicMarketingDateRangeSelectionEnum.SevenDays]: {
            name: 'BASICMARKETING_SEVENDAYS',
            status: PresetStatus.LastSevenDays,
            enumId: BasicMarketingDateRangeSelectionEnum.SevenDays
        },
        [BasicMarketingDateRangeSelectionEnum.FourteenDays]: {
            name: 'BASICMARKETING_FOURTEENDAYS',
            status: PresetStatus.LastFourteenDays,
            enumId: BasicMarketingDateRangeSelectionEnum.FourteenDays
        },
        [BasicMarketingDateRangeSelectionEnum.ThirtyDays]: {
            name: 'BASICMARKETING_THIRTYDAYS',
            status: PresetStatus.LastThirtyDays,
            enumId: BasicMarketingDateRangeSelectionEnum.ThirtyDays
        },
        [BasicMarketingDateRangeSelectionEnum.SixtyDays]: {
            name: 'BASICMARKETING_SIXTYDAYS',
            status: PresetStatus.LastSixtyDays,
            enumId: BasicMarketingDateRangeSelectionEnum.SixtyDays
        },
        [BasicMarketingDateRangeSelectionEnum.NinetyDays]: {
            name: 'BASICMARKETING_NINETYDAYS',
            status: PresetStatus.LastNinetyDays,
            enumId: BasicMarketingDateRangeSelectionEnum.NinetyDays
        },
        [BasicMarketingDateRangeSelectionEnum.OneEightyDays]: {
            name: 'BASICMARKETING_ONEEIGHTYDAYS',
            status: PresetStatus.LastOneEightyDays,
            enumId: BasicMarketingDateRangeSelectionEnum.OneEightyDays
        },
        [BasicMarketingDateRangeSelectionEnum.OneTwentyDays]: {
            name: 'BASICMARKETING_ONETWENTYDAYS',
            status: PresetStatus.LastOneTwentyDays,
            enumId: BasicMarketingDateRangeSelectionEnum.OneTwentyDays
        },
        [BasicMarketingDateRangeSelectionEnum.SinceLastWeek]: {
            name: 'BASICMARKETING_SINCELASTWEEK',
            status: PresetStatus.LastWeek,
            enumId: BasicMarketingDateRangeSelectionEnum.SinceLastWeek
        },
        [BasicMarketingDateRangeSelectionEnum.SinceLastMonth]: {
            name: 'BASICMARKETING_SINCELASTMONTH',
            status: PresetStatus.LastMonth,
            enumId: BasicMarketingDateRangeSelectionEnum.SinceLastMonth
        },
        [BasicMarketingDateRangeSelectionEnum.OneYear]: {
            name: 'BASICMARKETING_ONEYEAR',
            status: PresetStatus.LastYear,
            enumId: BasicMarketingDateRangeSelectionEnum.OneYear
        },
        [BasicMarketingDateRangeSelectionEnum.Custom]: {
            name: 'LABEL_CUSTOM',
            status: PresetStatus.Custom,
            enumId: BasicMarketingDateRangeSelectionEnum.Custom
        },
    };
    const DATE_RANGE_TRANSLATES = {
        [BasicMarketingDateRangeSelectionEnum.FourteenDays]: 'BASICMARKETING_FOURTEENDAYS',
        [BasicMarketingDateRangeSelectionEnum.Last7Days]: 'BASICMARKETING_LASTSEVENDAYS',
        [BasicMarketingDateRangeSelectionEnum.LastMonth]: 'BASICMARKETING_LASTMONTH',
        [BasicMarketingDateRangeSelectionEnum.LastQuarter]: 'BASICMARKETING_LASTQUARTER',
        [BasicMarketingDateRangeSelectionEnum.LastWeek]: 'BASICMARKETING_LASTWEEK',
        [BasicMarketingDateRangeSelectionEnum.NextMonth]: 'BASICMARKETING_NEXTMONTH',
        [BasicMarketingDateRangeSelectionEnum.NextQuarter]: 'BASICMARKETING_NEXTQUARTER',
        [BasicMarketingDateRangeSelectionEnum.NextWeek]: 'BASICMARKETING_NEXTWEEK',
        [BasicMarketingDateRangeSelectionEnum.NinetyDays]: 'BASICMARKETING_NINETYDAYS',
        [BasicMarketingDateRangeSelectionEnum.OneDay]: 'BASICMARKETING_ONEDAY',
        [BasicMarketingDateRangeSelectionEnum.OneEightyDays]: 'BASICMARKETING_ONEEIGHTYDAYS',
        [BasicMarketingDateRangeSelectionEnum.OneTwentyDays]: 'BASICMARKETING_ONETWENTYDAYS',
        [BasicMarketingDateRangeSelectionEnum.PreviousDay]: 'BASICMARKETING_PREVIOUSDAY',
        [BasicMarketingDateRangeSelectionEnum.SevenDays]: 'BASICMARKETING_SEVENDAYS',
        [BasicMarketingDateRangeSelectionEnum.SixtyDays]: 'BASICMARKETING_SIXTYDAYS',
        [BasicMarketingDateRangeSelectionEnum.ThirtyDays]: 'BASICMARKETING_THIRTYDAYS',
        [BasicMarketingDateRangeSelectionEnum.ThisMonth]: 'BASICMARKETING_THISMONTH',
        [BasicMarketingDateRangeSelectionEnum.ThisQuarter]: 'BASICMARKETING_THISQUARTER',
        [BasicMarketingDateRangeSelectionEnum.ThisWeek]: 'BASICMARKETING_THISWEEK',
        [BasicMarketingDateRangeSelectionEnum.Today]: 'BASICMARKETING_TODAY',
        [BasicMarketingDateRangeSelectionEnum.Tomorrow]: 'BASICMARKETING_TOMORROW',
        [BasicMarketingDateRangeSelectionEnum.TwentyFourHours]: 'BASICMARKETING_TWENTYFOURHOURS',
        [BasicMarketingDateRangeSelectionEnum.Any]: 'BASICMARKETING_ANY',
        [BasicMarketingDateRangeSelectionEnum.ThisYear]: 'BASICMARKETING_THISYEAR',
        [BasicMarketingDateRangeSelectionEnum.LastYear]: 'BASICMARKETING_LASTYEAR',
        [BasicMarketingDateRangeSelectionEnum.SinceLastWeek]: 'BASICMARKETING_SINCELASTWEEK',
        [BasicMarketingDateRangeSelectionEnum.SinceLastMonth]: 'BASICMARKETING_SINCELASTMONTH',
        [BasicMarketingDateRangeSelectionEnum.OneYear]: 'BASICMARKETING_ONEYEAR',
        [BasicMarketingDateRangeSelectionEnum.Custom]: 'LABEL_CUSTOM',
    };

    class ClientSelectionExportDatePikerComponent implements ng.IComponentController {
        static $inject = [
            '$timeout',
            '$rootScope',
        ];
        //#region bindings
        public startModel: Date;
        public endModel: Date;
        public dateRangeModel: BasicMarketingDateRangeSelectionEnum;
        public dateRanges: IDateRange[];
        public onChange: () => {};
        public disabled: boolean;
        //#endregion

        public selectedDatePreset: IPreset = null;
        public startDayOfWeek = 1;
        public presetList: IPreset[] = [];
        public dateRangeTranslates = DATE_RANGE_TRANSLATES;
        public hasCustom: boolean = false;
        public validationJson: IValidationJson;
        
        constructor(private $timeout: ng.ITimeoutService, private $rootScope: ng.IRootScopeService) {
            this.startDayOfWeek = this.$rootScope.appointmentBookSettings.startAppointmentBookDayOn;
        }

        public $onChanges() {
            this.presetList = [];
            this.hasCustom = false;

            if (!this.dateRanges || !this.dateRanges.length) {
                return;
            }

            this.dateRanges
                .sort((a, b) => a.order - b.order)
                .forEach((dateRange) => {
                    const preset = MAP_DATE_RANGE_TO_PRESET[dateRange.dateRangeEnum];
                    if (!!preset) {
                        this.presetList.push(preset);
                        if (dateRange.isDefault) {
                            this.selectedDatePreset = preset;
                            this.dateRangeModel = this.selectedDatePreset.enumId;
                        }

                        if (dateRange.dateRangeEnum === BasicMarketingDateRangeSelectionEnum.Custom) {
                            this.hasCustom = true;
                            try {
                                this.validationJson = JSON.parse(dateRange.validationJson);
                            } catch (e) {
                                this.validationJson = <IValidationJson>{};
                            }
                        }
                    }
                });
        }
        
        public dateChanged() {
            this.dateRangeModel = this.selectedDatePreset.enumId;
            this.$timeout(() => this.onChange(), 0);
        }
    }

    angular.module('meevo.plugins.basicEmailMarketing')
        .component('meevoClientSelectionExportDatePiker', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/basicEmailMarketing/components/date-picker/date-picker.template.html',
            controller: ClientSelectionExportDatePikerComponent,
            controllerAs: '$ctrl',
            bindings: {
                startModel: '=',
                endModel: '=',
                dateRangeModel: '=',
                dateRanges: '=',
                onChange: '&',
                disabled: '=?ngDisabled'
            }
        });
}
